import { render, staticRenderFns } from "./CatalogNav.vue?vue&type=template&id=d08e12fc"
import script from "./CatalogNav.vue?vue&type=script&lang=js"
export * from "./CatalogNav.vue?vue&type=script&lang=js"
import style0 from "./CatalogNav.vue?vue&type=style&index=0&id=d08e12fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports